import { WORKOUT_SECTION_KEY, WORKOUT_SECTION_TYPE } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function isCircuitWorkoutSectionUtil (workoutSection) {
  return getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.TYPE) ===
    WORKOUT_SECTION_TYPE.CIRCUIT
}

export default isCircuitWorkoutSectionUtil
